/**
 * "12 / 40 Firmen · 18 Kontakte", from the counters the worker mirrors onto a run's job.
 *
 * @param {{processed?: number, total?: number, contactsFound?: number}|undefined} progress
 * @returns {string|null} null while the job carries no total yet
 */
export const progressCounts = (progress) => {
	if (!progress?.total) return null;
	const companies = `${progress.processed ?? 0} / ${progress.total} Firmen`;
	return typeof progress.contactsFound !== 'number' ? companies : `${companies} · ${progress.contactsFound} Kontakte`;
};
